import React, { PureComponent } from "react";
import { View, TouchableOpacity, Image, Text, Linking } from "react-native";
import dayjs from "dayjs";

class BookReturnedTransactionEmployee extends PureComponent {
  state = {
    numberOfLines: 3,
    bufferedAudio: "",
    audioPlayState: "STOP",
  };
  handleClick = () => {
    if (this.props.onPress) {
      const { _id, Employee, BookReturned, _createdAt } = this.props;
      this.props.onPress({
        _id,
        type: "ACTIVITY_ITEM_PRESSED",
        Employee,
        BookReturned,
        _createdAt,
      });
    }
  };
  render() {
    const { BookReturned, _createdAt } = this.props;

    if (!BookReturned) {
      return null;
    }
    return (
      <View
        style={{
          paddingVertical: 7,
        }}
      >
        <TouchableOpacity onClick={this.handleClick} activeOpacity={0.6}>
          <View
            style={{
              marginHorizontal: 5,
              paddingBottom: 4,
              borderRadius: 2,
              backgroundColor: "white",
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.2,
              shadowRadius: 2,
              elevation: 1,
            }}
          >
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <View style={{ padding: 10 }}>
                <Image
                  style={{
                    width: 100,
                    height: 100,
                    resizeMode: "cover",
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                  source={require("../../assets/buku_out.png")}
                />
              </View>
              <View
                style={{
                  paddingTop: 10,
                  paddingBottom: 10,
                  flex: 1,
                  flexDirection: "column",
                }}
              >
                <View
                  style={{
                    alignItems: "left",

                    // justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      fontWeight: "bold",
                      marginTop: 2,
                    }}
                  >
                    <i
                      className="fa fa-check-circle"
                      style={{
                        color: "#27ae60",
                      }}
                    />{" "}
                    PENGEMBALIAN BUKU
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#00a8ff",
                      marginTop: 2,
                    }}
                  >
                    {dayjs(_createdAt).format("dddd, DD MMMM YYYY HH:mm")}
                  </Text>
                </View>

                <View
                  style={{
                    flex: 1,
                    alignItems: "flex-start",
                    marginTop: 10,
                    marginBottom: 5,
                    // justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    Buku: {BookReturned.bookName}
                  </Text>
                </View>
                <View
                  style={{
                    // flex: 1,
                    // alignItems: "flex-start",
                    marginBottom: 15,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    Oleh: {BookReturned.studentName}
                  </Text>
                </View>
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#2196f3",
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    <i className="fa fa-calendar" /> Tgl. Kembali{" "}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#2196f3",
                      marginEnd: 12,
                    }}
                  >
                    {BookReturned.returnDate}
                  </Text>
                </View>
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#EF5350",
                    }}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    <i className="fa fa-coins" /> Denda (Rp)
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: "#EF5350",
                      marginEnd: 12,
                    }}
                  >
                    {Number(BookReturned.totalFines)
                      .toLocaleString("id-ID")
                      .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      </View>
    );
  }
}

export default BookReturnedTransactionEmployee;
